<template>
  <div class="actions-container">
    <a-dropdown v-if="canMoveBackToBeSentToAgency || canMoveBackToBeApproved"
                v-bind:trigger="['click']">
      <a-menu slot="overlay">
        <a-menu-item key="1" v-on:click="moveBackToBeReceived">
          Te ontvangen van klant
        </a-menu-item>
        <a-menu-item key="2" v-on:click="moveBackToBeSentToAgency" v-if="canMoveBackToBeSentToAgency">
          Te versturen naar maatschappij
        </a-menu-item>
        <a-menu-item key="3" v-on:click="moveBackToBeApproved" v-if="canMoveBackToBeApproved">
          Goed te keuren door maatschappij
        </a-menu-item>
      </a-menu>
      <a-button :style="{opacity: (hasItemsToDecline  ? '1.0' : '0.6')}"
                :type="hasItemsToDecline ? 'danger' : 'secondary'"
                :loading="loadingBack"
      >
        {{ countDeclineItems }} Afwijzen
      </a-button>
    </a-dropdown>

    <a-button v-else
              :style="{opacity: (hasItemsToDecline  ? '1.0' : '0.6')}"
              :type="hasItemsToDecline ? 'danger' : 'secondary'"
              :loading="loadingBack"
              @click="moveBackToBeReceived"
    >
      {{ countDeclineItems }} Afwijzen
    </a-button>

    <a-modal
        title="Geef een reden"
        :visible="showCommentModal"
        :body-style="{padding:'15px'}"
        @ok="onCommentModalOk"
        @cancel="onCommentModalCancel"
    >
      <a-card v-for="(item, index) in itemsToMove"
              :key="index"
              :title="item.name"
              :bordered="false">
        <a-textarea
            ref="commentModalCommentInput"
            placeholder="Notitie (niet verplicht)"
            v-model="item.comment"
            :auto-size="{ minRows: 2, maxRows: 6 }"
        />
      </a-card>

      <a-card title="Wil je de klant informeren?" :bordered="false">
        <!-- TODO customerHasBeenNotifiedToday implementeren wanneer logica hiervoor is toegevoegd.           -->
        <!--  check of klant vandaag al een e-mail heeft ontvangen                                            -->
        <!--  over afgekeurde stukken in deze hypotheek.                                                      -->
        <!--  <a-alert-->
        <!--      v-if="customerHasBeenNotifiedToday"-->
        <!--      message="Binnen deze hypotheek zijn vandaag al stukken afgekeurd waar de klant over is geïnformeerd.-->
        <!--               Wil je de klant opnieuw informeren?"-->
        <!--      type="warning"-->
        <!--      :show-icon="true"-->
        <!--      style="margin-bottom: 0.5em"-->
        <!--  />-->

        <a-radio-group v-model="notifyCustomer" :default-value="false" button-style="solid">
          <a-radio-button :value=true>
            Ja
          </a-radio-button>
          <a-radio-button :value=false>
            Nee
          </a-radio-button>
        </a-radio-group>

        <a-alert
            v-if="notifyCustomer"
            message="Na bevestigen ga je automatisch naar e-mail versturen."
            type="info"
            :show-icon="true"
            style="margin-top: 0.5em"
        />
      </a-card>

      <template slot="footer">
        <a-button key="cancel" type="default" @click="onCommentModalCancel">
          Annuleer
        </a-button>
        <a-button key="confirm" type="primary" :loading="loading" @click="onCommentModalOk">
          Bevestig
        </a-button>
      </template>
    </a-modal>

  </div>
</template>

<script>
import mortgageProgressApi from '~/api/mortgage_progress'
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'DeclineMortgageProgressesComponent',
  props: {
    declineItems: {
      type: Array,
      required: true,
      default: []
    },
  },
  data () {
    return {
      loading: false,
      loadingBack: false,
      itemsToMove: [],
      showCommentModal: false,
      notifyCustomer: false,
      customerHasBeenNotifiedToday: false,
    }
  },
  methods: {
    ...mapActions({
      updateMortgageProgressesWithState: '$_mortgage_progress/updateMortgageProgressesWithState',
    }),
    moveBackToBeReceived () {
      if (this.canMoveBackToBeReceived) {
        this.itemsToMove = []

        this.declineItems.forEach(item => {
          item = { ...item, received: false, sent: false, completed: false }
          this.itemsToMove.push(item)
        })

      this.moveBack()
      }
    },
    moveBackToBeSentToAgency () {
      if (this.canMoveBackToBeSentToAgency) {
        this.itemsToMove = []

        this.declineItems.forEach(item => {
          item = { ...item, received: true, sent: false, completed: false }
          this.itemsToMove.push(item)
        })

      this.moveBack()
      }
    },
    moveBackToBeApproved () {
      if (this.canMoveBackToBeApproved) {
        this.itemsToMove = []

        this.declineItems.forEach(item => {
          item = { ...item, received: true, sent: true, completed: false }
          this.itemsToMove.push(item)
        })

        this.moveBack()
      }
    },
    moveBack () {
      this.loadingBack = true
      this.showCommentModal = true

      this.$nextTick(() => {
        this.$refs.commentModalCommentInput[0].focus()
      })
    },
    onCommentModalOk () {
      this.loading = true
      this.loadingComment = true

      mortgageProgressApi.updateMultiple(this.itemsToMove)
          .then(() => {
            this.$emit('declined')

            this.updateMortgageProgressesWithState(this.itemsToMove, 'state')

            if (this.notifyCustomer) {
              this.navigator.navigatePath(this.route('vue.customer.email.create.for.instance', {
                customerId: this.mortgage.customer_id,
                category: this.mortgage.id,
                instanceClass: 'App\\Models\\Mortgage',
                instanceId: this.mortgage.id,
                template_name_in_system: 'Klant informeren stukken afgewezen',
              }));
            }
          })
          .catch((error) => {
            this.$notification['error']({
              message: 'Er ging iets mis',
              description: 'Het is niet gelukt de geselecteerde documenten af te wijzen.',
            })
          })
          .finally(() => {
            this.loading = false
            this.loadingComment = false
            this.showCommentModal = false
            this.loadingBack = false
            this.notifyCustomer = false
          })
    },
    onCommentModalCancel () {
      this.showCommentModal = false
      this.notifyCustomer = false
      this.loadingBack = false
    },
  },
  computed: {
    ...mapGetters({
      mortgage: "$_mortgage_progress/mortgage",
      mortgageProgresses: "$_mortgage_progress/mortgageProgresses",
    }),
    hasItemsToDecline () {
      return this.countDeclineItems > 0;
    },
    countDeclineItems () {
      return this.declineItems.length;
    },
    canMoveBackToBeReceived () {
      if (this.hasItemsToDecline) {
        return this.declineItems[0].received === true
      } else {
        return false;
      }
    },
    canMoveBackToBeSentToAgency () {
      if (this.hasItemsToDecline) {
        return this.declineItems[0].sent === true
      } else {
        return false;
      }
    },
    canMoveBackToBeApproved () {
      if (this.hasItemsToDecline) {
        return this.declineItems[0].completed === true
      } else {
        return false;
      }
    },
  },
}
</script>

<style scoped>
.actions-container {
  padding: 0.3em;
  text-align: right;
}

</style>
